"use client"
import { Image, Video } from "@opensea/next-ui-kit"
import { classNames, Flex } from "@opensea/ui-kit"
import ReactHlsPlayer from "react-hls-video-player"
import type { CollectionOverviewMediaType } from "../../../../types"

type NarrativeMediaProps = {
  className?: string
  isBackground?: boolean
  media: CollectionOverviewMediaType | null
  onReady?: () => void
}

export function NarrativeMedia({
  className,
  isBackground,
  media,
  onReady,
}: NarrativeMediaProps) {
  if (!media) {
    return (
      <Flex
        className={classNames(
          isBackground ? "absolute inset-0" : "relative aspect-video w-full",
          'z-0 bg-bg-additional-2 before:absolute before:inset-0 before:z-[1] before:bg-black/20 before:content-[""] dark:before:bg-transparent',
        )}
      />
    )
  }

  switch (media.mediaType) {
    case "ImageMedia":
      return (
        <Image
          alt=""
          className={classNames("object-cover object-center", className)}
          fill
          onLoad={onReady}
          src={media.imageUrl}
        />
      )
    case "VideoMedia":
      return (
        <div
          className={classNames(
            isBackground
              ? "absolute inset-0 z-0"
              : "-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 z-0 aspect-video w-full",
          )}
        >
          <Video
            autoPlay
            className={classNames(
              "block h-full w-full bg-black",
              isBackground ? "object-cover object-center" : "object-contain",
              className,
            )}
            controls={!isBackground}
            format="mp4"
            loop
            muted
            onCanPlay={onReady}
            playsInline
            src={media.videoUrl}
          />
        </div>
      )
    case "MuxVideoMedia":
      return (
        <div
          className={classNames(
            isBackground
              ? "absolute inset-0 z-0"
              : "-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 z-0 aspect-video w-full",
          )}
        >
          <ReactHlsPlayer
            autoPlay
            className={classNames(
              "block h-full w-full bg-black",
              isBackground ? "object-cover object-center" : "object-contain",
            )}
            controls={!isBackground}
            loop
            muted
            playsInline
            poster={media.thumbnailUrl ?? undefined}
            src={`https://stream.mux.com/${media.muxPlaybackId}.m3u8`}
          />
        </div>
      )
    default:
      return null
  }
}
